import React from 'react';
import topIcon from '../../images/vertical-align-top-icon.png';

function Top() {
    return(
        <span className="Nav-top" onClick={() => {window.scrollTo({ top: 0, behavior: "smooth" })}}><img src={topIcon} alt="vertical align top icon"/></span>
    )
}

export default Top;